import { useQuery } from '@tanstack/react-query';

import { userQueryOptions } from './query-options';

export const useGetUserDataQuery = () => useQuery(userQueryOptions.getUserDataQueryOptions());
